import { useMutation, useQueryClient } from '@tanstack/react-query';
import { resolveNextValidStatus } from './status-flow';
import { useDispatch } from 'react-redux';
import { workorderServicesRequest } from 'modules/WorkLog/actions/workOrderServiceActions';
import NOB from '../../../constants/language-strings';
export const useChangeWorkOrderStatus = () => {
    var _a, _b, _c;
    const queryClient = useQueryClient();
    const dispatch = useDispatch();
    const { mutate: changeWorkOrderStatus, isLoading: isChangeStatusLoading, error, } = useMutation({
        mutationFn: ({ workOrderId, currentStatus }) => resolveNextValidStatus(workOrderId, currentStatus),
        onSuccess: (finalStatus, { workOrderId }) => {
            queryClient.setQueryData([['workorder'], workOrderId], (old) => old ? Object.assign(Object.assign({}, old), { status: finalStatus }) : old);
            queryClient.invalidateQueries({ queryKey: ['workorder'] });
            dispatch(workorderServicesRequest(workOrderId));
        }
    });
    const changeStatusError = error
        ? error.message ||
            `${NOB.WORKORDER_BUTTON.ERROR} ${(_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : ""} ${NOB.WORKORDER_BUTTON.CONTACT_KETIL}`
        : null;
    return {
        changeWorkOrderStatus,
        isChangeStatusLoading,
        changeStatusError,
    };
};
